import EventBus from "../eventBus"; // We are using EventBus to control the YouTube player on a component level
var CONFIG = require("../config.json");
const APIkey = CONFIG.YT_API_KEY; // We keep our API key in a config file

export default {
  setCuePoint({ state }, payload) {
    // Promise to set current time before proceeding
    payload.time.then(result => {
      state.volatile.currentTime = result; // store current timeline position in store
      // Search for the right note and set cue point
      state.volatile.pads.forEach(pad => {
        if (pad.note === payload.note) {
          pad.cuePoint = state.volatile.currentTime; // use currentTime to set cue point after Promise
        }
      });
      state.volatile.videos.forEach(video => {
        if (video.id === state.volatile.currentVidId) {
          video.cuePoints = state.volatile.pads;
        }
      });
    });
  },
  incrementCuePoint({ state }, note) {
    return new Promise(resolve => {
      // Search for the right note and increment cue point
      state.volatile.pads.forEach(pad => {
        if (pad.note === note) {
          pad.cuePoint = pad.cuePoint + 0.05;
        }
      });
      // TODO: split this into distinct and reusable actions
      state.volatile.videos.forEach(video => {
        if (video.id === state.volatile.currentVidId) {
          video.cuePoints = state.volatile.pads;
        }
      });
      resolve();
    });
  },
  decrementCuePoint({ state }, note) {
    return new Promise(resolve => {
      // Search for the right note and decrement cue point
      state.volatile.pads.forEach(pad => {
        if (pad.note === note) {
          pad.cuePoint = pad.cuePoint - 0.05;
        }
      });
      // TODO: split this into distinct and reusable actions
      state.volatile.videos.forEach(video => {
        if (video.id === state.volatile.currentVidId) {
          video.cuePoints = state.volatile.pads;
        }
      });
      resolve();
    });
  },
  playNote({ commit }, note) {
    commit("setNote", note); // Set current note in store
    EventBus.$emit("YT_GOTO", note); // Emit timeline event to YouTubePlayer component
  },
  setVideo({ state, commit }, vidId) {
    // First check if the entered value looks like a YouTube video code
    const regexYT = new RegExp("[a-zA-Z0-9_-]{11}");
    if (regexYT.test(vidId)) {
      state.volatile.currentVidId = vidId; // Replace current video in player by input
      // If it is check if we have chopped it before
      const found = state.volatile.videos.some(video => video.id === vidId);
      if (!found) {
        // Wait for new YouTubePlayer component TODO: make this into a proper callback
        setTimeout(function() {
          EventBus.$emit("YT_GET_LENGTH"); // Emit get video length to YouTubePlayer component (return Promise to setVidLength)
        }, 50);
      } else {
        // When video exists in memory get the saved cue points
        const savedVideo = state.volatile.videos.filter(
          video => video.id === vidId
        )[0];
        commit("replacePads", savedVideo.cuePoints); // set cuepoints from memory
        commit("setCurrentTitle", savedVideo.title); // set title from memory
      }
    }
  },
  getVidTitle({ commit }, vidId) {
    // Fetch the video title from YouTube API v3
    return new Promise(resolve => {
      const baseURI =
        "https://www.googleapis.com/youtube/v3/videos?part=snippet&id=" +
        vidId +
        "&key=" +
        APIkey;
      fetch(baseURI)
        .then(response => response.json())
        .then(json => {
          const title = json.items[0].snippet.title;
          commit("setCurrentTitle", title);
          resolve(title);
        });
    });
  },
  setVidLength({ state }, payload) {
    return new Promise(resolve => {
      payload.then(result => {
        state.volatile.vidLength = result; // set full video length
        resolve(result);
      });
    });
  },
  saveVideo({ state, commit, dispatch }, payload) {
    return new Promise(resolve => {
      dispatch("addMemoryVideo", {
        title: state.volatile.currentVidTitle,
        id: state.volatile.currentVidId,
        memorySlot: payload
      }).then(result => {
        dispatch("storeInMemory", payload);
        resolve(result);
      });
      state.memoryPads["memory" + payload].used = true;
      commit("setActiveMemory", payload);
    });
  },
  addMemoryVideo({ state, commit }, payload) {
    return new Promise(resolve => {
      // Check if the video is already in this memory slot
      if (
        state.memoryPads["memory" + payload.memorySlot].content.some(video => {
          return video.id === payload.id;
        })
      ) {
        // Overwrite cue points if already in memory
        commit("overwriteExistingVideo", payload);
        resolve(
          "Cue points are overwritten in Memory Slot " + payload.memorySlot
        );
      } else {
        // Add video: unlimited video storage
        commit("addVideoToMemory", payload);
        resolve("Video was saved to Memory Slot " + payload.memorySlot);
      }
    });
  },
  storeInMemory({ state }, payload) {
    // store memory 1 - 4 in local storage
    localStorage.setItem(
      "memory" + payload,
      JSON.stringify(state.memoryPads["memory" + payload].content)
    );
  },
  clearMemory({ commit }, payload) {
    return new Promise(resolve => {
      localStorage.removeItem("memory" + payload); // clear memory in local storage
      commit("clearCopy", payload); // Remove memory from store
      resolve("All videos removed from Memory slot " + payload);
    });
  },
  setInitialCuepoints({ state, dispatch }, payload) {
    const timeSeg = state.volatile.vidLength / state.volatile.pads.length; // Divide video length by number of pads
    // set initial Cue Points based on equal divisions
    state.volatile.pads = state.volatile.pads.map((pad, index) => {
      return {
        cuePoint: timeSeg * index,
        note: pad.note
      };
    });
    dispatch("composeVidInfo", payload);
  },
  composeVidInfo({ commit, dispatch }, payload) {
    // First make sure we have the video title
    dispatch("getVidTitle", payload).then(result => {
      commit("addVideo", { id: payload, title: result });
    });
  },
  followVideoFromMemory({ state, commit }, payload) {
    return new Promise(resolve => {
      var n = {};
      // Replace current video and cue points in volatile memory
      Object.keys(state.volatile).forEach(key => {
        if (key == "currentVidId") {
          n[key] = payload.videoId;
        } else if (key == "currentVidTitle") {
          n[key] = payload.videoTitle;
        } else if (key == "pads") {
          n[key] = payload.cuePoints;
        } else {
          n[key] = state.volatile[key];
        }
      });
      commit("replaceVolatile", n);
      commit("setActiveMemory", payload.memoryNr); // Set memory loaded from active state
      resolve();
    });
  }
};
